import React, {useCallback, useMemo} from "react";
import {DataTable, DataTableColumnProps, DataTableUrl, OnErrorFn, useNotifications} from "peggirkit";
import {paginationSummaryFormatter} from "@/utils/PaginationUtils";
import {useIntl} from "react-intl";
import {notifyDanger} from "@/utils/NotifyUtils"
import {
    JobApplicationInDataTable,
    jobApplicationsDataTableBaseUrl,
    JobApplicationsFilterStatus
} from "@widgets/jobApplications/overview/JobApplications";
import {
    getJobApplicationsDataTableColumns
} from "@widgets/jobApplications/overview/table/columns/JobApplicationsDataTableColumns";
import {eatalianoAxios} from "@/data/api/http/axios";


const itemsPerPage = 20;

type Props = {
    dashboardLocation: number,
    statusFilter: JobApplicationsFilterStatus,
};

const JobApplicationsDataTable = ({dashboardLocation, statusFilter}: Props) => {
    const intl = useIntl();
    const {notify} = useNotifications();
    const dataUrl: DataTableUrl = useCallback(
        () => jobApplicationsDataTableBaseUrl(dashboardLocation, statusFilter),
        [dashboardLocation, statusFilter]);
    const columns: DataTableColumnProps<JobApplicationInDataTable>[] = useMemo(
        () => getJobApplicationsDataTableColumns(intl),
        [intl]);
    const onError: OnErrorFn = useCallback(
        () => notifyDanger(intl.formatMessage({id: "operationError"}), notify),
        [intl, notify]);

    return (
        <>
            <DataTable<JobApplicationInDataTable>
                label={intl.formatMessage({id: "jobApplications"})}
                url={dataUrl}
                axios={eatalianoAxios}
                paginationOptions={{
                    pageSize: itemsPerPage,
                    pageNumber: 0,
                    scrollToTopOnPageChange: true,
                    currentPageParameter: "page",
                }}
                columnSortingOptions={{
                    sortParameterName: "sort",
                }}
                paginationControl={{
                    navType: {type: "prevNext"},
                    paginationSummaryFormatter: paginationSummaryFormatter(intl),
                    breakpoints: {
                        sm: {navType: {type: "buttons"}},
                    },
                }}
                loadingConfig={{
                    skeletonRepeat: itemsPerPage,
                }}
                rowConfig={{
                    hoverEffect: true,
                }}
                columns={columns}
                size={"compact"}
                onError={onError}
                breakpoints={{md: {size: "normal"}}}
            />
        </>
    );
};

export default JobApplicationsDataTable;